'use client'

import React, { useEffect, useState } from 'react'


import pricingSearchFilters from '@/components/Pricing/searchBar/pricingSearchFilters'


import SearchBar from '@/components/UiElements/SearchBar'
import Pagination from '@/components/UiElements/Pagination'
import PriceListItem from '@/components/Pricing/Components/PriceListItem'
import { PricingFilter } from '@/types/pricing'
import Splash from '@/components/splash/Splash'
import getPrices from '@/services/ProductService/getPrices'
import PricingForm from './PricingForm'
import Modal from '@/components/Modal/Modal'
import mapSavedDataToList from '@/components/Pricing/mapData/mapSavedDataToList'
import mapLoadedPriceToList from '@/components/Pricing/mapData/mapLoadedPriceToList'
import { startNotif, closeNotif } from '@/components/DynamicForm/util/notifier';
import deletePricing from '@/services/PricingServices/deletePricing'


const perPage = 40

export default function Home() {



	const paginationRef = React.useRef<any>(null)
	const [prices, setPrices] = React.useState<Array<any>>([])
	const [filteredPrice, setFilteredPrice] = React.useState<Array<any>>([])
	const [total, setTotal] = React.useState<number>(0)
	const [loading, setLoading] = React.useState<boolean>(true)

	const [selectedPrice, setSelectedPrice] = useState<any>(null)
	const [isAddPriceModalOpen, setIsAddPriceModalOpen] = useState<boolean>(false)

	const [filter, setFilter] = useState<PricingFilter>({
		text: '',
		fixed: true,
		section: true,
		element: true,
		size: true,
	})




	const handleGetPageData = (pageNumber: number) => {
		const start = (pageNumber - 1) * perPage
		const end = start + perPage
		return filteredPrice.slice(start, end)
	}

	const handleGetPriceList = async () => {
		const list: any = await getPrices(1)
		if (!Array.isArray(list)) {
			setLoading(false)
			return
		}
		const mappedList = mapLoadedPriceToList(list)
		setTotal(Math.ceil(mappedList.length / perPage))
		setPrices(mappedList)
		setLoading(false)
	}

	const handleOpenModal = (item: any) => {
		setIsAddPriceModalOpen(true)
		setSelectedPrice(item)
	}




	const handleChangeFilter = (item: any) => {
		setFilter(currentFilter => {
			const updatedFilter = { ...currentFilter }
			switch (item.price_model) {
				case 'fixed':
					updatedFilter.fixed = item.enabled
					break
				case 'section':
					updatedFilter.section = item.enabled
					break
				case 'element':
					updatedFilter.element = item.enabled
					break
				case 'size':
					updatedFilter.size = item.enabled
					break
				default:
					break
			}
			return updatedFilter
		})
	}
	const handleCloseModal = () => {
		setIsAddPriceModalOpen(false)
		setSelectedPrice(null)
	}


	const handleOnUpdateSuccess = async (data: any) => {
		handleCloseModal()
		const mappedData = mapSavedDataToList(data)
		if (mappedData.new) {
			setPrices(currentPrices => [mappedData, ...currentPrices])
		} else {
			setPrices(currentPrices => currentPrices.map((item: any) => item.id === mappedData.id ? mappedData : item))
		}
		await handleGetPriceList()
	}



	const handleAddNewPrice = () => {
		setIsAddPriceModalOpen(true)
		setSelectedPrice({})
	}


	const handleDeleteModel = async (id: string) => {
		const toast = startNotif('Deleting pricing model...')

		const delRes = await deletePricing(id)
		if (delRes) {
			closeNotif(toast, 'Pricing model deleted successfully.')
			const updatedList = prices.filter((item: any) => item.id !== id);
			setPrices(updatedList)
		} else{
			closeNotif(toast, 'Failed to delete pricing model.', {
				type: 'error'
			})
		}


	}




	useEffect(() => {
		handleGetPriceList()
	}, [])



	useEffect(() => {

		const newList = prices.filter((price) => {
			const string = `${price.name.toLowerCase()}`
			const text = filter.text.toLowerCase()
			return string.includes(text)
		}).filter((price) => {
			return filter.section && price.price_model?.value?.toLowerCase() === 'section' ||
				filter.fixed && price.price_model?.value?.toLowerCase() === 'fixed' ||
				filter.element && price.price_model?.value?.toLowerCase() === 'element' ||
				filter.size && price.price_model?.value?.toLowerCase() === 'size';

		})

		setFilteredPrice(newList)
		setTotal(Math.ceil(newList.length / perPage))
	}, [filter, prices])


	useEffect(() => {
		paginationRef.current?.reset()
	}, [filteredPrice])



	return (
		<div className={'min-h-[100%] relative'}>
			<Modal isOpen={isAddPriceModalOpen} onClose={() => handleCloseModal()} title={selectedPrice?.id === "duplicate" ? "Duplicate Price" : selectedPrice?.id  ? "Edit Price" : "New Price"} closeOnOutsideClick={false}>
				<PricingForm model={selectedPrice} onUpdateSuccess={handleOnUpdateSuccess} closeModal={handleCloseModal}/>
			</Modal>
			<div className={'sticky top-[48px] bg-white z-[10]'}>
				<div className={'h-[48px] absolute top-[-48px] w-full bg-white z-[-1]'}></div>
				<SearchBar
					placeholder={'Search by pricing model name'}
					filters={pricingSearchFilters(prices, handleChangeFilter, filter)}
					searchText={filter.text}
					onChange={(text) => setFilter(prev => ({ ...prev, text }))}
					options={[
						{
							label: (
								<span className="flex flex-row gap-md">
									<span className="font-icon-solid text-primary">+</span>
									New Model
								</span>
							),
							onClick: handleAddNewPrice
						}
					]}
				/>
			</div>
			{loading && <Splash />}
			{(filteredPrice.length > 0 && total > 0) ?
				<Pagination
					ref={paginationRef}
					theme={(data) => {
						return (
							<PriceListItem model={data} callBack={handleOpenModal} onDelete={handleDeleteModel}/>
						)
					}}
					total={total}
					offset={150}
					getPageData={handleGetPageData}
					className={'pt-xxl'}
				/>
				:
				<div className={'flex flex-row justify-center items-center px-mx py-xl text-gray-300 bg-gray-50 rounded-md mt-xxl gap-lg h-[150px]'}>
					<p>
						<span>No results match your current filters. Try </span>
						<span
							className={'text-gray-300 underline cursor-pointer hover:text-gray-900 transition-all'}
							onClick={() => setFilter({
								text: '',
								section: true,
								fixed: true,
								element: true,
								size: false,
							})}
						>
							resetting some filters
						</span>
						<span> to see more options.</span>
					</p>
				</div>
			}
		</div>
	)
}
